import type { EditorValue } from '@octopus-do/octopus-editor'

export const isEditorValue = (content: unknown): content is EditorValue =>
  Array.isArray(content)
